export default __webpack_public_path__ + "static/media/view.8ea7e32d.svg";